import { Box, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Container = styled(Box)`
  width: 100%;
  row-gap: ${({ theme }) => getThemeSpacing(2, theme)};
  column-gap: ${({ theme }) => getThemeSpacing(4, theme)};
`
